import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA : service worker pour le mode hors-ligne (mobile/web uniquement, pas Electron ni Capacitor natif)
if ('serviceWorker' in navigator && !window.electronAPI && window.location.protocol.startsWith('http')) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch(() => {});
  });
}

// STOCKAGE PERSISTANT — empêche le navigateur d'effacer les données de l'utilisateur.
// Cause n°1 de pertes de données sur mobile : sans ça, Android/iOS considèrent la base
// IndexedDB comme du cache « jetable » et peuvent l'effacer seuls (souvent après quelques
// semaines → coïncide avec la fin de l'essai). On demande la persistance dès le chargement.
if (!window.electronAPI && navigator.storage && navigator.storage.persist) {
  navigator.storage.persisted()
    .then((granted) => (granted ? true : navigator.storage.persist()))
    .catch(() => {});
}
